export const AccessRightCodes = {
  Dashboard: "Dashboard",
  SettingsEnterprise: "SettingsEnterprise",
  SettingsAdvisor: "SettingsAdvisor",
};
